var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"crumb-container"},[_vm._v("\n    您当前所在位置："+_vm._s(_vm._f("formatPath")(_vm.menuPath))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }